export type RegistrationState = 'new' | 'partial' | 'complete';

export interface RegistrationStateData {
  state: RegistrationState;
  currentStep: RegistrationStep;
  userId?: string;
  partialId?: string;
  loading: boolean;
  error?: string;
}

export enum RegistrationStep {
  GET_STARTED = 1,
  BASIC_INFO = 2,
  PERSONAL_QUESTIONS = 3,
  INSURANCE = 4,
  DIAGNOSTIC = 5,
  FINAL_RESULTS = 6
} 